export default __webpack_public_path__ + "static/media/10_LeftToRightSquares_Alpha.48314cf0.mp4";